import React, { createContext, useContext, useEffect, useState } from 'react';

import LocalStorageUtils from '@qality/common-utils/src/LocalStorageUtils';

type FeedbackVisibilityContextValue = {
  isHidden: boolean;
  hideShareFeedback: () => void;
  storeShareFeedbackFlag: () => void;
};

export const FeedbackVisibilityContext =
  createContext<FeedbackVisibilityContextValue>({
    isHidden: true,
    hideShareFeedback: () => undefined,
    storeShareFeedbackFlag: () => undefined,
  });

export const useFeedbackVisibility = (): FeedbackVisibilityContextValue => {
  return useContext(FeedbackVisibilityContext);
};

const LOCAL_STORAGE_KEY = 'QALITY_FREE_FEEDBACK';

type Props = {
  children: React.ReactNode;
};

export default function FeedbackVisibilityProvider({
  children,
}: Props): JSX.Element {
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    readFromLocalStorage();
  }, []);

  const writeToLocalStorage = () => {
    LocalStorageUtils.storeUserSettings(true, LOCAL_STORAGE_KEY);
  };

  const readFromLocalStorage = () => {
    const readIsHidden =
      LocalStorageUtils.retrieveUserSettings<boolean>(LOCAL_STORAGE_KEY);
    setIsHidden(readIsHidden ?? false);
  };

  const hideShareFeedback = () => {
    setIsHidden(true);
  };

  return (
    <FeedbackVisibilityContext.Provider
      value={{
        isHidden,
        hideShareFeedback,
        storeShareFeedbackFlag: writeToLocalStorage,
      }}
    >
      {!isHidden && children}
    </FeedbackVisibilityContext.Provider>
  );
}
